/*
 * Sale promo popup (no email capture).
 *
 * Once per browser per campaign id, only inside the campaign window, after a short
 * delay. Closing it or clicking through retires it for that browser.
 * Fires GTM dataLayer events: promo_popup_shown / _dismissed / _clicked.
 */
(function () {
  'use strict';

  var CFG = window.PROMO_POPUP_CONFIG;
  if (!CFG) return;

  var root = document.getElementById('promo-popup');
  if (!root) return;

  var KEY = 'arccos:promo:' + CFG.id;
  var IMG_WAIT_MS = 1500;
  var lastFocus = null;

  function read(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }
  function write(key, value) {
    try { localStorage.setItem(key, value); } catch (e) { /* no-op */ }
  }

  function push(event, extra) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: event, promo_id: CFG.id };
    if (extra) Object.keys(extra).forEach(function (k) { payload[k] = extra[k]; });
    window.dataLayer.push(payload);
  }

  function inWindow() {
    var now = Date.now();
    var starts = Date.parse(CFG.startsAt);
    var ends = Date.parse(CFG.endsAt);
    if (!isNaN(starts) && now < starts) return false;
    if (!isNaN(ends) && now >= ends) return false;
    return true;
  }

  function onSkippedPath() {
    var path = window.location.pathname.replace(/\/+$/, '') || '/';
    return (CFG.skipPaths || []).some(function (p) {
      p = String(p || '').trim().replace(/\/+$/, '');
      return p && path === p;
    });
  }

  // Never stack on top of the paid-social email-capture popup.
  function otherPopupOpen() {
    var psec = document.getElementById('psec-root');
    return !!(psec && psec.getAttribute('data-open') === 'true');
  }

  function eligible() {
    if (window.Shopify && window.Shopify.designMode) return false;
    if (CFG.preview) return true;
    if (read(KEY)) return false;
    if (!inWindow()) return false;
    if (onSkippedPath()) return false;
    return true;
  }

  // The hero is inside a display:none dialog, so fetch it before opening rather
  // than letting the card appear with an empty image box.
  function preloadHero() {
    var img = root.querySelector('.promo-popup__img');
    var waits = [];
    if (img) {
      img.loading = 'eager';
      waits.push(img.decode ? img.decode().catch(function () {}) : Promise.resolve());
    }
    waits.push(loadHeadingFont());
    var cap = new Promise(function (resolve) { setTimeout(resolve, IMG_WAIT_MS); });
    return Promise.race([Promise.all(waits), cap]);
  }

  // Wait for the theme's own heading-font face the kicker uses (Bold, already declared
  // by the theme) so the headline never flashes in a fallback font.
  function loadHeadingFont() {
    try {
      if (!document.fonts || !document.fonts.load) return Promise.resolve();
      var kicker = root.querySelector('.promo-popup__kicker');
      if (!kicker) return Promise.resolve();
      var cs = getComputedStyle(kicker);
      return document.fonts.load(cs.fontWeight + ' 40px ' + cs.fontFamily).catch(function () {});
    } catch (e) {
      return Promise.resolve();
    }
  }

  function open() {
    lastFocus = document.activeElement;
    root.setAttribute('data-open', 'true');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    if (!CFG.preview) write(KEY, 'shown:' + Date.now());
    // Focus the card, not the CTA, so no focus ring is painted on open.
    var card = root.querySelector('.promo-popup__card');
    setTimeout(function () { if (card) card.focus({ preventScroll: true }); }, 300);
    push('promo_popup_shown', {
      device: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop'
    });
  }

  function close() {
    root.setAttribute('data-open', 'false');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  root.querySelectorAll('[data-promo-close]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      if (!CFG.preview) write(KEY, 'dismissed:' + Date.now());
      close();
      push('promo_popup_dismissed');
    });
  });

  root.querySelectorAll('[data-promo-cta]').forEach(function (el) {
    el.addEventListener('click', function () {
      if (!CFG.preview) write(KEY, 'clicked:' + Date.now());
      push('promo_popup_clicked', { cta: el.getAttribute('data-promo-cta') });
      document.documentElement.style.overflow = '';
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || root.getAttribute('data-open') !== 'true') return;
    if (!CFG.preview) write(KEY, 'dismissed:' + Date.now());
    close();
    push('promo_popup_dismissed', { via: 'escape' });
  });

  // Keep tab focus inside the dialog while it is open.
  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var items = root.querySelectorAll('button, a[href]:not([tabindex="-1"])');
    var visible = Array.prototype.filter.call(items, function (el) { return el.offsetParent !== null; });
    if (!visible.length) return;
    var first = visible[0];
    var last = visible[visible.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  function boot() {
    if (!eligible()) return;

    setTimeout(function () {
      // Re-check at fire time: the email-capture popup may have opened meanwhile.
      if (otherPopupOpen()) return;
      preloadHero().then(function () {
        if (!otherPopupOpen()) open();
      });
    }, CFG.preview ? 0 : (CFG.delayMs || 0));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
